export function getPromoContent(region, promoCode) {
  if (region && region.hasOwnProperty("hot_promos")) {
    if (promoCode && region.hot_promos.hasOwnProperty(promoCode)) {
      return region.hot_promos[promoCode].content;
    }
    return region.hot_promos["DEFAULT"].content;
  }
  return null;
}
